import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { isValidJoinCode, normalizeJoinCode } from '@floorpoll/shared';

/**
 * The code-entry controls, with no heading and no card.
 *
 * Join wraps these in its "Join a poll" card. The landing hero labels them
 * its own way. Owning codeInput and error here lets Join drop a useState it
 * only used in the no-code branch.
 */
export function JoinCodeForm() {
  const navigate = useNavigate();
  const [codeInput, setCodeInput] = useState('');
  const [error, setError] = useState<string | null>(null);

  function onSubmit(event: FormEvent) {
    event.preventDefault();
    const normalized = normalizeJoinCode(codeInput);
    if (isValidJoinCode(normalized)) navigate(`/j/${normalized}`);
    else setError('That code does not look right. Check the screen and try again.');
  }

  return (
    <form onSubmit={onSubmit}>
      <input
        aria-label="Join code"
        className="code-input"
        value={codeInput}
        onChange={(e) => setCodeInput(e.target.value.toUpperCase())}
        placeholder="ABC234"
        autoCapitalize="characters"
        autoComplete="off"
        maxLength={8}
      />
      {error ? (
        <p className="form-error" role="alert">
          {error}
        </p>
      ) : null}
      <button type="submit" className="block">
        Join
      </button>
    </form>
  );
}
